import styled from '@emotion/styled'
import { setColor } from './createStyle'

const Link = styled.a`
  ${setColor}
  &:hover {
    text-decoration: underline;
    ${setColor}
  }
`
const Arrow = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 5px;
  height: 10px;
  width: 10px;
  background: url(https://img2.shaadi.com/assests/2018/images/sprite-homepg-v5.png)
    no-repeat;
  background-position: ${props =>
    props.colorCode === '#ffffff' ? '0 -492px' : '0 -1047px'};
`
const HelpIcon = styled.span`
  display: inline-block;
  vertical-align: middle;
  width: 30px;
  height: 30px;
  margin: 0 10px 0 0;
  background: url(https://img2.shaadi.com/assests/2018/images/sprite-homepg-v5.png)
    no-repeat;
  background-position: ${props =>
    props.colorCode === '#ffffff' ? '0 -40px' : '0 0'};
`
export { Link, Arrow, HelpIcon }
